import "./legal-section.scss";

export default {
  /** divider between text portions */
  divider: "legal-divider",
  /** container for the component */
  legalSectionWrapper: "legal-section",
  /** specific to a hyperlink */
  link: "legal-link",
  /** text span */
  text: "legal-text",
}



// WEBPACK FOOTER //
// src/common/legal-section/legal-section.style.js